<script setup lang="ts">
    const { t, locale, locales } = useI18n()
    const switchLocalePath = useSwitchLocalePath()


    const languages = computed(() => {
        return locales.value.map((l) => {
            const code = typeof l === "string" ? l : l.code
            return {
                code,
                // switchLocalePath resolves the current route in the other locale,
                // instead of re-resolving an already prefixed path.
                path: switchLocalePath(code),
            }
        })
    })

</script>

<template>

    <ul class="language-selector" :aria-label="t('nav.language')">

        <li v-for="l of languages" :key="l.code" :class="{selected: l.code == locale}">
            <nuxt-link
                :to="l.path"
                :lang="l.code"
                :hreflang="l.code"
                :aria-current="l.code == locale ? 'true' : undefined"
            >{{ l.code.toUpperCase() }}</nuxt-link>
        </li>

    </ul>

</template>


<style scoped>

    ul {
        display: flex;
        flex-direction: row-reverse;
        gap: 0.74em;
        background: #e3e3e3;
        padding: 0.5em;
        box-sizing: border-box;
        border: 1px solid #e3e3e3;
        z-index: 200;
    }

    li {
        /* underlined */
        cursor: pointer;
        font-weight: 100;
        font-size: 0.75em
    }

    li a {
        text-decoration: none;
        color: inherit;
    }


    li.selected {
        color: var(--green-accent-color);
        /* Underline */
    }

    li.selected a {
        /* underline */
        text-decoration: underline;
    }


</style>